import { ObjectUtils } from "../../utils/ObjectUtils";

export class ClasseJudicial {
    static novo(partial: Partial<ClasseJudicial>): ClasseJudicial {
        return ObjectUtils.assign(new ClasseJudicial(), partial);
    }

    static novoComArray(partial: Partial<ClasseJudicial[]>): ClasseJudicial {
        const novo = new ClasseJudicial();
        if (partial && partial.length > 0) {
            novo.sigla = partial.map(classe => classe.sigla).join('-');
            novo.descricao = partial[0].descricao;
        } else {
            novo.sigla = "";
            novo.descricao = "";
        }
        return novo;
    }

    sigla: string = undefined;
    descricao: string = undefined;
}